import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Szukaj',
  },
  searchResults: {
    showMore: 'Pokaż więcej wyników',
    noResults: 'Nie znaleziono wyników!',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC™/PEFC™',
      ecofriendly: 'Eco',
      overnight: 'Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Projektowanie online',
    },
    taglines: {
      home: 'Mehr erfahren',
      text: 'Mehr erfahren',
      themes: 'Mehr erfahren',
      external: 'Mehr erfahren',
      info: 'Mehr erfahren',
      category: 'Mehr erfahren',
      content: 'Mehr erfahren',
      product: 'Jetzt konfigurieren',
    },
    headings: {
      categories: 'Catégories de produits',
      products: 'Produits',
      external: 'Autre site',
    },
    slider: {
      previousSlide: 'Show previous content',
      nextSlide: 'Show next content',
    },
  },
  searchInput: {
    inputTooShortError: 'Twoje zapytanie jest za krótkie (min 2)',
    results: 'Wyników',
    result: 'Wynik',
    youSearchFor: 'Szukałeś',
    suggestedTerm: {
      didYouMean: 'Czy miałeś na myśli',
      resultsFor: 'Kliknij tutaj, aby wyświetlić wszystkie wyniki',
      didYouMeanPostFix: '?',
      resultsForPostFix: '',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Widok listy',
      gridButtonTooltip: 'Widok kafelków',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Wyczyść wszystkie filtry',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filtry',
        buttonsTooltipLabel: 'Widok',
        resultLabel: 'Wyniki',
      },
      contexts:
        {
          product: 'Produkt',
          content: 'Zadowolony',
          all: 'all',
          category: 'Catégories de produits',
          external: 'Autre site',
        },
    },
    breadcrumbs: {
      start: 'Początek',
      search: 'Szukaj',
    },
  },
  sideBar: {
    filter: 'Filtr',
    filterOverwrite: {
      category: {
        text: 'Zadowolony',
      },
      rootCategory: {
        text: 'Zadowolony',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Projektowanie online',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Twoja sesja wygasła i musisz zalogować się ponownie. Zostaniesz natychmiast przekierowany do logowania.',
      server403: 'Żądanie nie zostało zastosowane, ponieważ brakuje w nim prawidłowych danych uwierzytelniających. Proszę przeładować stronę lub skontaktować się z naszym działem obsługi klienta.',
      default: 'Wystąpił błąd na serwerze. Prosimy o ponowne załadowanie strony lub kontakt z naszym działem obsługi klienta.',
    },
    errors: {
      server400: 'The request was malformed. Prosimy o ponowne załadowanie strony lub kontakt z naszym działem obsługi klienta.',
      server404: '404 Strona nie została znaleziona. Prosimy przejść do poprzedniej strony lub skontaktować się z naszym działem obsługi klienta.',
      server500: 'Wystąpił błąd na serwerze. Proszę przeładować stronę lub skontaktować się z naszym działem obsługi klienta.',
      server501: 'Wystąpił błąd na serwerze. Proszę przeładować stronę lub skontaktować się z naszym działem obsługi klienta.',
      server502: 'Wystąpił błąd na serwerze i otrzymasz nieprawidłową odpowiedź. Prosimy o ponowne załadowanie strony lub kontakt z naszym działem obsługi klienta.',
      server503: 'Wystąpił błąd na serwerze. Prosimy o ponowne załadowanie strony lub kontakt z naszym działem obsługi klienta.',
      server504: 'Wystąpił błąd na serwerze. Proszę przeładować stronę lub skontaktować się z naszym biurem obsługi klienta.',
      default: 'Serwer ma problem z żądaniem. Prosimy o ponowne załadowanie strony lub kontakt z naszym działem obsługi klienta.',
    },
  },
};
export default translation;
